import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
  public showMenu = false;

  private readonly UNAUTHENTICATED_NAME = 'Usuário não Autenticado';
  private readonly UNAUTHENTICATED_EMAIL = 'sem e-mail';

  private _userName: string = this.UNAUTHENTICATED_NAME;
  private _userEmail: string = this.UNAUTHENTICATED_EMAIL;

  constructor(private readonly auth: AuthService) {}

  ngOnInit(): void {
    this._userName = this.auth.getUserName() || this.UNAUTHENTICATED_NAME;
    this._userEmail = this.auth.getUserEmail() || this.UNAUTHENTICATED_EMAIL;
  }

  get userName(): string {
    return this._userName;
  }

  get userEmail(): string {
    return this._userEmail;
  }

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }

  async logout(): Promise<void> {
    this.showMenu = false;
    try {
      await this.auth.logout();
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  }

  // Gera cor de fundo única com bom contraste para cada userName
  get avatarBgColor(): string {
    if (!this.userName) return '#666';
    let hash = 0;
    for (let i = 0; i < this.userName.length; i++) {
      hash = (this.userName.codePointAt(i) ?? 0) + ((hash << 5) - hash);
    }
    // Gera cor no espaço HSL, variando apenas o matiz para garantir variedade e legibilidade
    const hue = Math.abs(hash) % 360;
    const saturation = 60;
    const lightness = 55;
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }

  // Define cor do texto baseada no contraste (sempre preto ou branco)
  get avatarTextColor(): string {
    if (!this.userName) return '#fff';
    let hash = 0;
    for (let i = 0; i < this.userName.length; i++) {
      hash = (this.userName.codePointAt(i) ?? 0) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    const saturation = 60;
    const lightness = 55;

    const c = ((1 - Math.abs((2 * lightness) / 100 - 1)) * saturation) / 100;
    const x = c * (1 - Math.abs(((hue / 60) % 2) - 1));
    const m = lightness / 100 - c / 2;
    let r: number, g: number, b: number;
    if (hue < 60) {
      r = c;
      g = x;
      b = 0;
    } else if (hue < 120) {
      r = x;
      g = c;
      b = 0;
    } else if (hue < 180) {
      r = 0;
      g = c;
      b = x;
    } else if (hue < 240) {
      r = 0;
      g = x;
      b = c;
    } else if (hue < 300) {
      r = x;
      g = 0;
      b = c;
    } else {
      r = c;
      g = 0;
      b = x;
    }

    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance > 140 ? '#222' : '#fff';
  }

  get avatarInitial(): string {
    return this.userName ? this.userName.charAt(0).toUpperCase() : '';
  }
}
